import React from 'react'
import Styled from 'styled-components'

import ReactLogo from '../../images/react-logo.svg'

const ProductsList = ({ siteTitle }) => (
    <ProductsListWrapper>
      <Product>
        <img src={ReactLogo} alt={siteTitle} />
        <ProductInfo>
          <p>Shards React</p>
          <span>Documentation</span>
        </ProductInfo>
      </Product>
    </ProductsListWrapper>
)

export default ProductsList

const ProductsListWrapper = Styled.div`
  position: relative;

  &:before {
    content: '';
    position: absolute;
    width: 1px;
    height: 28px;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    background: #e9e8f1;
  }

  @media (max-width: 780px) {
    display: table;
    margin: 0 auto;
    position: relative;
    left: -20px;

    &:before {
      display: none;
    }
  }
`

const Product = Styled.div`
  display: flex;
  padding-left: 10px;
  padding-right: 30px;
  
  img {
    max-width: 20px;
    max-height: 20px;
    margin: 5px 10px;
  }
`

const ProductInfo = Styled.div`
  line-height: 1;
  margin-left: 5px;

  p { /* 'Shards React' */
    margin: 0;
    font-weight: 500;
    font-size: 15px;
    line-height: 1;
    color: #3b454e;
  }

  span { /* 'Documentation' */
    color: #767e8f;
    font-size: 13px;
  }
`